/** Shared network + payload-key resolution for all FE apps (same helper as custom-form-builder). */

export const readEnv = (name) =>
	String(process.env[name] || "")
		.trim()
		.replace(/^['"]|['"]$/g, "");

export const createNetworkEnv = ({
	network,
	baseUrls,
	authenticationKeys,
	encryptionKey = "",
	payloadEncryptionEnabled = false,
} = {}) => {
	const NETWORK = network || "DEMO";
	const BASE_URL = baseUrls?.[NETWORK] || "";

	return {
		NETWORK,
		BASE_URL,
		resolvePayloadEncryptionKey: () => encryptionKey || "",
		// Always the key of NETWORK: the backend picks its key by its own NETWORK.
		resolvePayloadAuthenticationKey: () =>
			authenticationKeys?.[NETWORK] || "",
		isPayloadEncryptionEnabledForNetwork: () =>
			String(payloadEncryptionEnabled).toLowerCase() === "true",
	};
};
